module.exports = __webpack_public_path__ + "img/money.dca546aa.png";